import { useTranslation } from '@/hooks/useTranslation';
import { useEffect, useRef, useState } from 'react';

const NumbersSection = () => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect(); }
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="numbers" ref={ref}>
      {t.numbers.items.map((item, i) => (
        <div className="num-item" key={i}>
          <span className="num-val">
            <Counter end={item.value} suffix={item.suffix} active={visible} />
          </span>
          <span className="num-label">{item.label}</span>
        </div>
      ))}
    </section>
  );
};

function Counter({ end, suffix, active }: { end: number; suffix: string; active: boolean }) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    const duration = 2000;
    const startTime = performance.now();
    const step = (now: number) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setVal(Math.floor(eased * end));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [active, end]);
  return <>{val}{suffix}</>;
}

export default NumbersSection;
